
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MainMenu',
  props: {
    middleLogo: Boolean,
  },
});
